
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToProducts = () => {
    const productsSection = document.getElementById('products');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-amber-500 to-orange-500 rounded-full">
              <i className="ri-leaf-line text-white text-2xl"></i>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800" style={{ fontFamily: 'Pacifico, serif' }}>
                한의사 방앗간
              </h1>
              <p className="text-sm text-gray-600">노원장 하이엔드 참기름 & 들기름</p>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">홈</a>
            <a href="#products" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">제품</a>
            <a href="#about" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">소개</a>
            <a href="#contact" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">문의</a>
            <button 
              onClick={scrollToProducts}
              className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-2 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>주문하기
            </button>
          </nav>

          <button 
            className="md:hidden text-gray-700 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">홈</a>
              <a href="#products" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">제품</a>
              <a href="#about" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">소개</a>
              <a href="#contact" className="text-gray-700 hover:text-amber-600 font-medium cursor-pointer">문의</a>
              <button 
                onClick={scrollToProducts}
                className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-2 rounded-full hover:shadow-lg transition-all whitespace-nowrap cursor-pointer w-fit"
              >
                <i className="ri-phone-line mr-2"></i>주문하기
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
